/**
 * @file index.tsx
 *
 * @fileoverview Shows a text next to an image.
 */

import React from "react";
import styles from "./imageText.module.scss";

export interface ImageTextProps {
  /**
   * The image to show next to the text.
   */
  image: React.ReactNode;
  /**
   * The text to show.
   */
  children: React.ReactNode;
}

/**
 * This component provides an image with a text underneath.
 */
export const ImageText = ({ image, children, ...props }: ImageTextProps) => {
  return (
    <div className={styles.imageTextWrapper}>
      {image}
      <p className={styles.text}>{children}</p>
    </div>
  );
};

export default ImageText;
